"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bitMatrixToImageData = void 0;
var tslib_1 = require("tslib");
var bitMatrixToImageData = function (bitMatrix, color, to) {
    var _a = tslib_1.__read(color, 4), r = _a[0], g = _a[1], b = _a[2], a = _a[3];
    bitMatrix.data.forEach(function (bool, idx) {
        to.data[4 * idx + 0] = r;
        to.data[4 * idx + 1] = g;
        to.data[4 * idx + 2] = b;
        to.data[4 * idx + 3] = 255 * a * bool; // automatically rounded by Uint8ClampedArray
    });
    return to;
};
exports.bitMatrixToImageData = bitMatrixToImageData;
